module.exports = __webpack_public_path__ + "static/img/paper-75.3c78d355.png";